import { render, staticRenderFns } from "./TbcReleaseLoan.vue?vue&type=template&id=3f859d76&"
import script from "./TbcReleaseLoan.vue?vue&type=script&lang=js&"
export * from "./TbcReleaseLoan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports